import type { TProps } from './t.types'

import { vui } from '../core'
import T from './t'

export const Lead = vui<'span', TProps>((props, ref) => (
  <T ref={ref} size="xl" variant="caption" color="seaBlue.main" {...props} />
))
